export enum SynchronousCourseTypes {
  external = 1,
  faceToFace = 2,
}
